export default "__VITE_ASSET__B1GjgC70__"